<template>
    <b-card no-body>

        <b-modal id="create-pdf" size="lg" title="HGS İptal Başvuru PDF Oluştur" no-close-on-esc no-close-on-backdrop>
            <is-bankasi-hgs-cancel-pdf-create v-model="pdf"></is-bankasi-hgs-cancel-pdf-create>
            <template #modal-footer><v-executer :loading="loading" text="PDF Oluştur" :action="createPdf"></v-executer></template>
        </b-modal>

        <b-modal id="send" size="lg" title="HGS İptal Başvurusunu İlet" no-close-on-esc no-close-on-backdrop>
            <is-bankasi-hgs-cancel-send v-model="cancel"></is-bankasi-hgs-cancel-send>
            <template #modal-footer><v-executer :loading="loading" text="İlet" :action="sendCancel"></v-executer></template>
        </b-modal>

        <b-modal id="detail" size="lg" title="İptal Başvurusu Detayı" no-close-on-esc hide-footer no-close-on-backdrop>
            <is-bankasi-hgs-cancel-detail v-model="detail"></is-bankasi-hgs-cancel-detail>
        </b-modal>

        <v-table    ref="table"
                        :add-callback="createNew"
                        :items-provider="provider"
                        :fields="fields"
                        name="isbankasi-hgs-cancel"
                        pagination="server"
                        button-alignment="text-left"
                        :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import Additional from '@/utilities/additional'
import IsbankasiHGSOperationApi from '@/api/isbankasi-hgs-operations'
import IsBankasiHGSCancelPDFCreate from './components/IsBankasiHGSCancelPDFCreate.vue'
import IsBankasiHGSCancelSend from './components/IsBankasiHGSCancelSend.vue'
import IsBankasiHGSCancelDetail from './components/IsBankasiHGSCancelDetail.vue'

export default {
    components:{
        BCard,
        'is-bankasi-hgs-cancel-pdf-create':IsBankasiHGSCancelPDFCreate,
        'is-bankasi-hgs-cancel-send':IsBankasiHGSCancelSend,
        'is-bankasi-hgs-cancel-detail':IsBankasiHGSCancelDetail,
    },
    data() {
        return {
            fields:[
                {name:"Başvuru No", key:"ApplicationCode",thClass:'w-25'},
                {name:"Kredi Kartı", key:"CreditCardNumber",thClass:'w-25'},
                {name:"İşlemi Yapan", key:"CreatedBy",thClass:'w-25'},
                {name:"İşlem Tarihi", key:"SentTime",thClass:'w-25'},
            ],
            buttons:[
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"primary",action:this.download },
                { text:"İmzalı Belgeyi İndir",key:"download-signed",icon:"DownloadIcon",variant:"warning",action:this.downloadSigned, condition:(item) => item.IsSent },
                { text:"İlet",key:"send",icon:"SendIcon",variant:"success",action:this.send,condition:(item) => !item.IsSent },
                { text:"Detay",key:"send",icon:"EyeIcon",variant:"secondary",action:this.showDetail },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete,condition:(item) => !item.IsSent },
            ],
            loading:false,
            pdf:{
                CreditCardNumber:null,
                PlatesOfHGSCancelApplications:[],
            },
            detail:{
                ApplicationCode: null,
                ApplicationText:null,
                CreatedBy:null,
                CreditCardNumber:null,
                Id:null,
                IsSent:null,
                PlatesOfHGSCancelApplications:[],
                SentTime:null
            },
            cancel:{
                Id:null,
                ApplicationText:"",
                Attachment:null,
                ToMailAddress:null 
            }
        }
    },
    methods:{
        clearForm(){
            this.pdf.CreditCardNumber = null
            this.pdf.PlatesOfHGSCancelApplications = []
            this.cancel.ApplicationText = ""
            this.cancel.Id = null
            this.cancel.Attachment = null
            this.cancel.ToMailAddress = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-pdf')
        },
        provider(data){
            return IsbankasiHGSOperationApi.Cancel.Table(data)
        },
        download(item,btnKey,index,bool){
            let id = bool ? item : item.Id
            if(!bool) this.$refs.table.rowLoading(true)
            IsbankasiHGSOperationApi.Cancel.DownloadPDF(id).then(_res=>{
                Additional.DownloadFile(_res.data,'HGSİptal.pdf')
                if(bool){
                    this.$hideModal('create-pdf')
                    this.loading = false
                }else this.$refs.table.rowLoading(false)
            }).catch(err=>{
                if(bool){
                    this.loading = false
                }else this.$refs.table.rowLoading(false)
            })
        },
        send(item){
            this.clearForm()
            this.cancel.Id = item.Id
            this.$showModal('send')
        },
        downloadSigned(item){
            this.$refs.table.rowLoading(true)
            IsbankasiHGSOperationApi.Cancel.DownloadSignedPDF(item.Id).then(_res=>{
                Additional.DownloadFile(_res.data,'HGSİptal.pdf')
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
            })
        },
        showDetail(item){
            this.$refs.table.rowLoading(true)
            IsbankasiHGSOperationApi.Cancel.Get(item.Id).then(res=>{
                this.detail.ApplicationCode = res.data.Data.ApplicationCode
                this.detail.ApplicationText = res.data.Data.ApplicationText
                this.detail.CreatedBy = res.data.Data.CreatedBy
                this.detail.CreditCardNumber = res.data.Data.CreditCardNumber
                this.detail.Id = res.data.Data.Id
                this.detail.IsSent = res.data.Data.IsSent
                this.detail.PlatesOfHGSCancelApplications = res.data.Data.PlatesOfHGSCancelApplications
                this.detail.SentTime = res.data.Data.SentTime
                this.$showModal('detail')
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
            })
        },
        createPdf(){
            this.loading = true
            IsbankasiHGSOperationApi.Cancel.CreatePDF(this.pdf).then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.download(res.data.Data,null,null,true)
                    this.$refs.table.refresh()
                }
                this.loading = false
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        async sendCancel(){
            this.loading = true
            let formData = await Additional.ToFormData(this.cancel,['Attachment'])
            IsbankasiHGSOperationApi.Cancel.Send(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('send')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.ApplicationCode} numaralı iptal başvurusunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    IsbankasiHGSOperationApi.Cancel.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>